module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--2-d4466641.png";